export default "__VITE_ASSET__YxnCkWxe__"